import React from "react";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Checkbox } from "./ui/checkbox";
import { AuthImg, UploadButton } from "./AuthImg";
import { X } from "lucide-react";

export const UTILITY_ITEMS = [
  { key: "wasser", num: 1, label: "Wasser", emoji: "💧", placeholder: "ex: robinet în curte, apă de la vecin…" },
  { key: "strom", num: 2, label: "Strom", emoji: "⚡", placeholder: "ex: tablou la subsol, prelungitor 50m necesar…" },
  { key: "zugang", num: 3, label: "Zugang", emoji: "🚪", placeholder: "OBLIGATORIU detalii acces: cheie, cod poartă, persoană de contact…" },
];

export const ProjectUtilitiesSection = ({ value, onChange }) => {
  const util = value || {};
  const upd = (key, patch) =>
    onChange({ ...util, [key]: { checked: false, text: "", images: [], ...(util[key] || {}), ...patch } });

  return (
    <div className="md:col-span-2 border border-zinc-200 rounded-lg p-3 bg-zinc-50/60" data-testid="project-utilities-section">
      <Label className="text-xs font-bold uppercase tracking-wide text-zinc-600">🔌 Detalii șantier — Wasser / Strom / Zugang</Label>
      <div className="mt-2 space-y-3">
        {UTILITY_ITEMS.map((it) => {
          const v = util[it.key] || {};
          return (
            <div key={it.key} className="bg-white border border-zinc-200 rounded-md p-2.5" data-testid={`utility-${it.key}`}>
              <label className="flex items-center gap-2 cursor-pointer select-none">
                <Checkbox
                  checked={!!v.checked}
                  onCheckedChange={(c) => upd(it.key, { checked: !!c })}
                  data-testid={`utility-check-${it.key}`}
                />
                <span className="text-sm font-bold">{it.num}. {it.emoji} {it.label}</span>
                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${v.checked ? "bg-emerald-100 text-emerald-700" : "bg-zinc-100 text-zinc-500"}`}>
                  {v.checked ? "✓ există / rezolvat" : "nebifat"}
                </span>
              </label>
              <Textarea
                rows={it.key === "zugang" ? 2 : 1}
                value={v.text || ""}
                onChange={(e) => upd(it.key, { text: e.target.value })}
                placeholder={it.placeholder}
                className="mt-1.5 text-sm"
                data-testid={`utility-text-${it.key}`}
              />
              <div className="mt-1.5 flex items-center gap-2 flex-wrap">
                {(v.images || []).map((img, idx) => (
                  <span key={img.file_id} className="relative inline-block group">
                    <AuthImg fileId={img.file_id} className="w-14 h-14 object-cover rounded border border-zinc-200" alt={img.name || ""} />
                    <button
                      type="button"
                      onClick={() => upd(it.key, { images: (v.images || []).filter((_, i) => i !== idx) })}
                      className="absolute -top-1.5 -right-1.5 bg-red-600 text-white rounded-full p-0.5 opacity-0 group-hover:opacity-100 transition-opacity"
                      data-testid={`utility-img-remove-${it.key}-${idx}`}
                      title="Șterge imaginea"
                    >
                      <X size={10} />
                    </button>
                  </span>
                ))}
                <UploadButton
                  label="📷 Imagine"
                  accept="image/*"
                  testId={`utility-upload-${it.key}`}
                  onUploaded={(f) => upd(it.key, { images: [...(util[it.key]?.images || []), { file_id: f.id || f.file_id, name: f.original_filename || f.name || "" }] })}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
